// extracted by mini-css-extract-plugin
export default {"user":"User_user__fVVps","content":"User_content__f2cSI","sideMenu":"User_sideMenu__-XHdc","actions":"User_actions__+QkX5","action":"User_action__Dcffz"};